import React, {Component} from 'react'
import {connect} from 'react-redux'
import PropTypes from "prop-types";

import {updateValues} from '../../../routers/data'
import {updateSettings, fetchAvailableCalcs} from '../../../routers/settings'
import Calendar from '../calendar/calendar'

import Swal from 'sweetalert2'

class formDepartureDate extends Component{
  static contextTypes = {
    router: PropTypes.object
  }

  onClickMove = (value) => {
    const result = {month: parseInt(value[0], 0), year: parseInt(value[1], 0)}
    this.props.updateSettings({'departureMove': result})
  }

  onClickSelect = (value) => {
    if(value < this.props.returnDate || this.props.returnDate === undefined){ 
      const {travel, returndate} = this.props.data.values
      if (travel === 0){
        this.props.updateSettings({'tab': 4})
        this.props.updateValues({'departuredate': value})
      }else{
        if (returndate < value){
          this.props.updateValues({'departuredate': value, returndate: undefined})
        } else {
          this.props.updateValues({'departuredate': value})
        }
      }
    }else{ 
      Swal(
        'Oops!',
        'Lo sentimos, pero no puedes escoger una fecha de ida posterior a la de vuelta.',
        'error'
      )
    }
  }

  onClickNext = (val) => {
    const {travel} = this.props.data.values
    switch (travel) {
      case 1:
        window.scrollTo(0, 0)
        this.props.updateSettings({'tab': undefined})
        this.props.fetchAvailableCalcs(this.props.data ,this.props.settings)
        break;
      default:
        this.props.updateSettings({'tab': val})
    }
  }

  render(){
    const langUrl = this.context.router.route.location.pathname.split('/')[1]
    const { languages } = this.props.settings
    const langPlace = languages[langUrl].fastbooking.departure

    const {departureMove, availabledates} = this.props.settings
    const {travel, departuredate, returndate} = this.props.data.values
    const {enable} = this.props
    const footerProps = (enable) ? {onClick: () => this.onClickNext(4)}: undefined
    const nextProps = (enable) ? {className: 'next'}: {className: 'next-disabled'}

    const nextButton = (travel === 0)? <span {...nextProps}>{langPlace.confirm}<i className="fa fa-chevron-circle-right" aria-hidden="true"/></span>:
                                      <span {...nextProps}>{langPlace.find}<i className="fa fa-search" aria-hidden="true"/></span>

    const classContainer = (travel === 0)? 'container-departure container-fluid': 'container-only-departure container-fluid'

    const now = new Date(Date.now())
    const nowDate = new Date(now.getFullYear(), now.getMonth(), now.getDate())
    const nowDate3 = new Date(now.getFullYear(), now.getMonth() + 3, now.getDate() - 1)

    const mReturndate = (travel === 1)? undefined: returndate
    const de = new Date(departuredate)
    const re = new Date(mReturndate)
    const select = [de, re]

    const vi = (mReturndate !== undefined)? re: nowDate3
    const view = [nowDate, vi]

    let filter = []
    if (availabledates !== undefined){
      if (availabledates.departures !== undefined){
        filter = availabledates.departures
      }else {
        alert('error en Api')
      }
    }

    return (
			<div className={classContainer}>

        <div className='panel-departure row'>
            <div className='date-title'><p>{langPlace.selectdate}</p></div>
            <Calendar move={departureMove} view={view} select={select} filter={filter}
              onClickMove={this.onClickMove} onClickSelect={this.onClickSelect}/>
        </div>

        <div className='footer row' {...footerProps}>
          {nextButton}
        </div>

      </div>
    )
  }
}

export default connect(
	(state) => ({settings: state.settings, data: state.data}),
  {updateSettings, updateValues, fetchAvailableCalcs}
)(formDepartureDate)



// WEBPACK FOOTER //
// ./src/shared/routes/components/fastbooking/panelDepartureDate.js